import parse from 'html-react-parser';
import { Link } from 'react-router-dom';

export default function Service({ iconUrl, title, subTitle, imgUrl, href }) {
  return (
    <div className="cs_service cs_style_1 cs_pt_25 cs_pl_25 cs_pr_25 cs_pb_15 bg-white cs_transition_4 shadow cs_mb_25 h-100">
      <div className="cs_service_iconbox d-flex align-items-center cs_mb_20">
        <div className="cs_service_icon d-flex align-items-center justify-content-center cs_rounded_5 cs_mr_15 cs_transition_4 flex-none">
          <img src={iconUrl} alt="Icon" />
        </div>
        <h2 className="cs_lh_base cs_fs_20 cs_fs_lg_18 m-0">
          <Link to={href} className="inline-block">
            {parse(title)}
          </Link>
        </h2>
      </div>
      <p className="cs_mb_24">{parse(subTitle)}</p>
      <div className="cs_service_thumb position-relative cs_rounded_5">
        <div
          className="cs_service_thumb-in position-relative-in background-filled h-100"
          style={{
            backgroundImage: `url(${imgUrl})`,
          }}
        />
      </div>
    </div>
  );
}
